import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Segment, Sidebar } from 'semantic-ui-react'
import InvoiceConfigurationForm from "./InvoiceConfigurationForm";
import InvoiceConfigurationsListContainer from "./InvoiceConfigurationsListContainer";
import InvoiceConfigurationsMenuContainer from "./InvoiceConfigurationsMenuContainer";

class InvoiceConfigurations extends React.Component {
  render () {
    return (
      <div>
        <Switch>
          <Route path={Routes.invoice_configuration_path({ id: ":id", _options: true})} render={ props => (
            <Sidebar.Pushable as={Segment} className= "min-height-90">
              <InvoiceConfigurationsMenuContainer/>
              <Sidebar.Pusher className="left-sidebar-margin">
                <InvoiceConfigurationForm entityId={props.match.params.id} />
              </Sidebar.Pusher>
            </Sidebar.Pushable>
           )} />
          <Route path={Routes.invoice_configurations_path()}  render={(props) => <InvoiceConfigurationsListContainer/> }/>
        </Switch>
      </div>
    )
  }
}

export default InvoiceConfigurations;

